import request from '../request'

// 网站配置信息
export function fetchConfig() {
    return request({
        url: '/Api/Base/getConfig',
    })
}